import { gql, useQuery } from '@apollo/client'

export interface IQueryDataType {
  locationGroups: {
    nodes: {
      id: number
      name: string
      type: string
      disable: boolean
    }[]
  }
}

const query = gql`
  query locationGroups {
    locationGroups {
      nodes {
        id
        name
        type
        disable
      }
    }
  }
`

const useListLocationGroup = () => useQuery<IQueryDataType>(query)

export default useListLocationGroup
